import { __assign, __extends, __spreadArrays } from "tslib";
import { CoherencePanel } from '@cseo/coherence-panel';
import { classNamesFunction, Link, Persona, PersonaCoin, PersonaInitialsColor, PersonaSize } from '@fluentui/react';
import React from 'react';
import { CoherenceNotificationPanel } from '../notification';
import { HeaderBanner } from './Components/HeaderBanner';
import { NotificationControl } from './Components/NotificationControl';
var CoherenceHeaderBase = (function (_super) {
    __extends(CoherenceHeaderBase, _super);
    function CoherenceHeaderBase(props) {
        var _this = _super.call(this, props) || this;
        _this._getClassNames = classNamesFunction();
        _this._ignoreOverflowButtonFocus = false;
        _this._onFarRightButtonDismissed = function () {
            _this.setState(function (prevState) { return ({
                panelVisible: prevState.nextPanelVisible ? prevState.nextPanelVisible : prevState.panelVisible,
                nextPanelVisible: prevState.nextPanelVisible ? undefined : prevState.nextPanelVisible
            }); }, function () {
                if (!_this.state.panelVisible && !_this._ignoreOverflowButtonFocus) {
                    var overflowButton = (document.getElementById('coher-header-overflow-button-id'));
                    if (overflowButton) {
                        overflowButton.focus();
                    }
                    _this._ignoreOverflowButtonFocus = true;
                }
            });
        };
        _this._onPanelChange = function (nextPanelType) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
            _this.setState(function (prevState) { return ({
                panelVisible: prevState.panelVisible ? undefined : nextPanelType,
                nextPanelVisible: prevState.panelVisible ? nextPanelType : undefined
            }); }, function () {
                _this._ignoreOverflowButtonFocus = nextPanelType === 'Profile';
            });
            var farRightSettings = _this.props.farRightSettings;
            switch (nextPanelType) {
                case 'Notifications':
                    (_c = (_a = farRightSettings === null || farRightSettings === void 0 ? void 0 : farRightSettings.notificationsSettings) === null || _a === void 0 ? void 0 : (_b = _a.panelSettings).onClick) === null || _c === void 0 ? void 0 : _c.call(_b);
                    break;
                case 'Help':
                    (_f = (_d = farRightSettings === null || farRightSettings === void 0 ? void 0 : farRightSettings.helpSettings) === null || _d === void 0 ? void 0 : (_e = _d.panelSettings).onClick) === null || _f === void 0 ? void 0 : _f.call(_e);
                    break;
                case 'Settings':
                    (_j = (_g = farRightSettings === null || farRightSettings === void 0 ? void 0 : farRightSettings.settingsSettings) === null || _g === void 0 ? void 0 : (_h = _g.panelSettings).onClick) === null || _j === void 0 ? void 0 : _j.call(_h);
                    break;
                case 'Feedback':
                    {
                        if (farRightSettings === null || farRightSettings === void 0 ? void 0 : farRightSettings.feedbackSettings) {
                            _this.setState({ panelVisible: undefined, nextPanelVisible: undefined });
                            if (!farRightSettings.feedbackSettings.panelSettings.onClick()) {
                                return;
                            }
                        }
                        var launchOptions = ((_k = farRightSettings === null || farRightSettings === void 0 ? void 0 : farRightSettings.feedbackSettings) === null || _k === void 0 ? void 0 : _k.panelSettings.launchOptions) || {};
                        OfficeBrowserFeedback.multiFeedback(launchOptions).catch(function (err) {
                            console.log('OCV Feedback Submission Failed with error: ' + err);
                        });
                    }
                    break;
                case 'Profile':
                    (_o = (_l = farRightSettings === null || farRightSettings === void 0 ? void 0 : farRightSettings.profileSettings) === null || _l === void 0 ? void 0 : (_m = _l.panelSettings).onClick) === null || _o === void 0 ? void 0 : _o.call(_m);
                    break;
                default:
                    break;
            }
        };
        _this._closePanel = function (ev) {
            if ((ev === null || ev === void 0 ? void 0 : ev.type) === 'click' || (ev === null || ev === void 0 ? void 0 : ev.nativeEvent.key) === 'Escape') {
                _this.setState({ panelVisible: undefined, nextPanelVisible: undefined });
                if (_this.props.dismissOpenedPanel && _this.props.onDismissOpenedPanel) {
                    _this.props.onDismissOpenedPanel();
                }
            }
        };
        _this._skipToMainClicked = function () {
            var mainTags = document.getElementsByTagName('main');
            if (mainTags.length) {
                mainTags[mainTags.length - 1].focus();
                return;
            }
            var divsWithMain = (document.querySelectorAll('[role="main"]'));
            if (divsWithMain) {
                divsWithMain[divsWithMain.length - 1].focus();
            }
        };
        _this.onClickNotifications = function () {
            _this._onFarRightButtonClicked('Notifications');
            _this.updateNewNotifications();
        };
        _this.updateNewNotifications = function () {
            var _a, _b, _c;
            var farRightSettings = _this.props.farRightSettings;
            (_c = (_a = farRightSettings === null || farRightSettings === void 0 ? void 0 : farRightSettings.notificationsSettings) === null || _a === void 0 ? void 0 : (_b = _a.panelSettings).onPanelOpened) === null || _c === void 0 ? void 0 : _c.call(_b);
        };
        _this.getSettingsControl = function () {
            var _a, _b, _c, _d, _e;
            var buttonSettings = (_b = (_a = _this.props.farRightSettings) === null || _a === void 0 ? void 0 : _a.settingsSettings) === null || _b === void 0 ? void 0 : _b.buttonSettings;
            return {
                key: 'settings',
                text: (_c = buttonSettings === null || buttonSettings === void 0 ? void 0 : buttonSettings.title) !== null && _c !== void 0 ? _c : 'Settings',
                value: 'Settings',
                title: (_d = buttonSettings === null || buttonSettings === void 0 ? void 0 : buttonSettings.title) !== null && _d !== void 0 ? _d : 'Settings',
                ariaLabel: (_e = buttonSettings === null || buttonSettings === void 0 ? void 0 : buttonSettings.ariaLabel) !== null && _e !== void 0 ? _e : 'Settings',
                checked: _this.state.panelVisible === 'Settings',
                iconProps: {
                    iconName: 'Settings'
                },
                onClick: function () { return _this._onFarRightButtonClicked('Settings'); }
            };
        };
        _this.getHelpControl = function () {
            var _a, _b, _c, _d, _e;
            var buttonSettings = (_b = (_a = _this.props.farRightSettings) === null || _a === void 0 ? void 0 : _a.helpSettings) === null || _b === void 0 ? void 0 : _b.buttonSettings;
            return {
                key: 'help',
                text: (_c = buttonSettings === null || buttonSettings === void 0 ? void 0 : buttonSettings.title) !== null && _c !== void 0 ? _c : 'Help',
                value: 'Help',
                ariaLabel: (_d = buttonSettings === null || buttonSettings === void 0 ? void 0 : buttonSettings.ariaLabel) !== null && _d !== void 0 ? _d : 'Help',
                title: (_e = buttonSettings === null || buttonSettings === void 0 ? void 0 : buttonSettings.title) !== null && _e !== void 0 ? _e : 'Help',
                checked: _this.state.panelVisible === 'Help',
                iconProps: {
                    iconName: 'Help'
                },
                onClick: function () { return _this._onFarRightButtonClicked('Help'); }
            };
        };
        _this.getFeedbackControl = function () {
            var _a, _b, _c, _d, _e, _f, _g;
            var buttonSettings = (_b = (_a = _this.props.farRightSettings) === null || _a === void 0 ? void 0 : _a.feedbackSettings) === null || _b === void 0 ? void 0 : _b.buttonSettings;
            var ocvButtonIsFocused = ((_d = (_c = _this.props.farRightSettings) === null || _c === void 0 ? void 0 : _c.feedbackSettings) === null || _d === void 0 ? void 0 : _d.panelSettings.ocvButtonIsFocused) || false;
            return {
                id: 'coher-header-ocv-button-id',
                key: 'feedback',
                text: (_e = buttonSettings === null || buttonSettings === void 0 ? void 0 : buttonSettings.title) !== null && _e !== void 0 ? _e : 'Feedback',
                value: 'Feedback',
                ariaLabel: (_f = buttonSettings === null || buttonSettings === void 0 ? void 0 : buttonSettings.ariaLabel) !== null && _f !== void 0 ? _f : 'Feedback',
                title: (_g = buttonSettings === null || buttonSettings === void 0 ? void 0 : buttonSettings.title) !== null && _g !== void 0 ? _g : 'Feedback',
                checked: ocvButtonIsFocused,
                iconProps: {
                    iconName: 'Emoji2'
                },
                onClick: function () { return _this._onFarRightButtonClicked('Feedback'); }
            };
        };
        _this.getPersonaCoin = function () {
            var _a, _b, _c, _d, _e, _f, _g;
            var buttonSettings = (_b = (_a = _this.props.farRightSettings) === null || _a === void 0 ? void 0 : _a.profileSettings) === null || _b === void 0 ? void 0 : _b.buttonSettings;
            var panelSettings = (_d = (_c = _this.props.farRightSettings) === null || _c === void 0 ? void 0 : _c.profileSettings) === null || _d === void 0 ? void 0 : _d.panelSettings;
            return {
                key: 'filter',
                title: (_f = (_e = buttonSettings === null || buttonSettings === void 0 ? void 0 : buttonSettings.title) !== null && _e !== void 0 ? _e : panelSettings === null || panelSettings === void 0 ? void 0 : panelSettings.fullName) !== null && _f !== void 0 ? _f : 'Profile',
                ariaLabel: (_g = buttonSettings === null || buttonSettings === void 0 ? void 0 : buttonSettings.ariaLabel) !== null && _g !== void 0 ? _g : 'Profile',
                checked: _this.state.panelVisible === 'Profile',
                iconProps: {
                    iconName: 'Filter'
                },
                onClick: function () { return _this._onFarRightButtonClicked('Profile'); },
                onRenderIcon: function () { return (React.createElement(PersonaCoin, { size: PersonaSize.size28, imageUrl: panelSettings === null || panelSettings === void 0 ? void 0 : panelSettings.imageUrl, initialsColor: PersonaInitialsColor.purple, text: panelSettings === null || panelSettings === void 0 ? void 0 : panelSettings.fullName })); }
            };
        };
        _this._onFarRightButtonClicked = function (panel) {
            _this._onPanelChange(_this.state.panelVisible === panel ? undefined : panel);
        };
        _this.getProfile = function () {
            var farRightSettings = _this.props.farRightSettings;
            if (farRightSettings && farRightSettings.profileSettings) {
                var profileSettings_1 = farRightSettings.profileSettings;
                var personaInfo = {
                    imageUrl: profileSettings_1.panelSettings.imageUrl,
                    initialsColor: PersonaInitialsColor.purple,
                    text: profileSettings_1.panelSettings.fullName,
                    secondaryText: profileSettings_1.panelSettings.emailAddress
                };
                return (React.createElement(React.Fragment, null,
                    React.createElement(Persona, __assign({}, personaInfo, { size: PersonaSize.size72, styles: _this._classNames.subComponentStyles.personaProfile, onRenderTertiaryText: function () {
                            if (profileSettings_1.panelSettings.viewAccountLink) {
                                return (React.createElement("div", { className: _this._classNames.personaLinkContainer },
                                    React.createElement(Link, { styles: _this._classNames.subComponentStyles.personaLink, href: profileSettings_1.panelSettings.viewAccountLink, onClick: _this.onClickViewAccount }, "View Account")));
                            }
                            else {
                                return null;
                            }
                        } })),
                    React.createElement("div", { className: _this._classNames.dividerStyle }),
                    _this.getProfileBody(),
                    !(profileSettings_1.panelSettings.hideSignOut) &&
                        React.createElement(React.Fragment, null,
                            !(profileSettings_1.panelSettings.hideSignOutDivider) && React.createElement("div", { className: _this._classNames.dividerStyle }),
                            React.createElement(Link, { styles: _this._classNames.subComponentStyles.personaLink, href: profileSettings_1.panelSettings.logOutLink, onClick: _this.onClickLogOut }, "Sign out"))));
            }
            else {
                return null;
            }
        };
        _this.onClickViewAccount = function () {
            var _a, _b, _c, _d;
            (_d = (_b = (_a = _this.props.farRightSettings) === null || _a === void 0 ? void 0 : _a.profileSettings) === null || _b === void 0 ? void 0 : (_c = _b.panelSettings).onViewAccount) === null || _d === void 0 ? void 0 : _d.call(_c);
        };
        _this.onClickLogOut = function () {
            var _a, _b, _c, _d;
            (_d = (_b = (_a = _this.props.farRightSettings) === null || _a === void 0 ? void 0 : _a.profileSettings) === null || _b === void 0 ? void 0 : (_c = _b.panelSettings).onLogOut) === null || _d === void 0 ? void 0 : _d.call(_c);
        };
        _this.getProfileBody = function () {
            var _a;
            var farRightSettings = _this.props.farRightSettings;
            if ((_a = farRightSettings === null || farRightSettings === void 0 ? void 0 : farRightSettings.profileSettings) === null || _a === void 0 ? void 0 : _a.panelSettings.body) {
                return (React.createElement(React.Fragment, null, farRightSettings.profileSettings.panelSettings.body));
            }
            return null;
        };
        _this.state = {
            panelVisible: undefined,
            nextPanelVisible: undefined
        };
        return _this;
    }
    CoherenceHeaderBase.prototype.componentWillReceiveProps = function (nextProps, prevProps) {
        if (nextProps.dismissOpenedPanel && nextProps.onDismissOpenedPanel
            && nextProps.dismissOpenedPanel !== prevProps.dismissOpenedPanel) {
            this.setState({ panelVisible: undefined, nextPanelVisible: undefined });
            nextProps.onDismissOpenedPanel();
        }
        else if (nextProps.displayPanel != prevProps.displayPanel) {
            if (this.state.panelVisible === undefined) {
                this._onFarRightButtonClicked(nextProps.displayPanel);
            }
        }
    };
    CoherenceHeaderBase.prototype.render = function () {
        var _this = this;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z;
        var _0 = this.props, appNameSettings = _0.appNameSettings, searchSettings = _0.searchSettings, navbarProps = _0.navbarProps, farRightSettings = _0.farRightSettings, styles = _0.styles, theme = _0.theme;
        var newNotifications = ((_a = farRightSettings === null || farRightSettings === void 0 ? void 0 : farRightSettings.notificationsSettings) === null || _a === void 0 ? void 0 : _a.panelSettings.newNotifications) || -1;
        var notificationItems = ((_b = farRightSettings === null || farRightSettings === void 0 ? void 0 : farRightSettings.notificationsSettings) === null || _b === void 0 ? void 0 : _b.panelSettings.items) || [];
        this._classNames = this._getClassNames(styles, { theme: theme });
        var appNameProps = {
            label: appNameSettings.label,
            linkUrl: appNameSettings.linkUrl,
            linkProps: {
                styles: this._classNames.subComponentStyles.appNameLink
            },
            ariaLabel: (_c = appNameSettings.ariaLabel) !== null && _c !== void 0 ? _c : appNameSettings.label
        };
        var searchBoxProps = searchSettings !== null && searchSettings !== undefined ? searchSettings : {};
        return (React.createElement(React.Fragment, null,
            React.createElement(Link, { href: "javascript:void(0)", className: this._classNames.skipToMainLinkStyles, tabIndex: 0, as: 'a', onClick: this._skipToMainClicked, onKeyPress: function (event) {
                    var code = event.keyCode || event.which;
                    if (code === 13 || code === 32) {
                        _this._skipToMainClicked();
                    }
                } }, "Skip to main content"),
            React.createElement(HeaderBanner, __assign({ headerLabel: this.props.headerLabel }, navbarProps, { theme: theme, actions: {
                    flexItems: this._getRightFlexItems(),
                    staticItems: this._getRightStaticItems()
                }, appNameSettings: appNameProps, searchBoxProps: __assign(__assign({}, searchBoxProps), { enabled: !!searchSettings }) })),
            React.createElement(CoherenceNotificationPanel, __assign({ titleText: (_e = (_d = farRightSettings === null || farRightSettings === void 0 ? void 0 : farRightSettings.notificationsSettings) === null || _d === void 0 ? void 0 : _d.panelSettings.titleText) !== null && _e !== void 0 ? _e : 'Notifications', isOpen: this.state.panelVisible === 'Notifications' }, (_g = (_f = this.props.farRightSettings) === null || _f === void 0 ? void 0 : _f.notificationsSettings) === null || _g === void 0 ? void 0 : _g.panelSettings, { items: notificationItems, newNotifications: newNotifications, onDismissPanel: this._closePanel, onDismissed: this._onFarRightButtonDismissed, hasCloseButton: false, backButton: (_h = farRightSettings === null || farRightSettings === void 0 ? void 0 : farRightSettings.notificationsSettings) === null || _h === void 0 ? void 0 : _h.panelSettings.backButton })),
            React.createElement(CoherencePanel, __assign({ titleText: (_k = (_j = farRightSettings === null || farRightSettings === void 0 ? void 0 : farRightSettings.settingsSettings) === null || _j === void 0 ? void 0 : _j.panelSettings.titleText) !== null && _k !== void 0 ? _k : 'Settings', isOpen: this.state.panelVisible === 'Settings' }, (_m = (_l = this.props.farRightSettings) === null || _l === void 0 ? void 0 : _l.settingsSettings) === null || _m === void 0 ? void 0 : _m.panelSettings, { onDismiss: this._closePanel, onDismissed: this._onFarRightButtonDismissed, hasCloseButton: false }), ((_p = (_o = this.props.farRightSettings) === null || _o === void 0 ? void 0 : _o.settingsSettings) === null || _p === void 0 ? void 0 : _p.panelSettings.body) || null),
            React.createElement(CoherencePanel, __assign({ titleText: (_r = (_q = farRightSettings === null || farRightSettings === void 0 ? void 0 : farRightSettings.helpSettings) === null || _q === void 0 ? void 0 : _q.panelSettings.titleText) !== null && _r !== void 0 ? _r : 'Help', isOpen: this.state.panelVisible === 'Help' }, (_t = (_s = this.props.farRightSettings) === null || _s === void 0 ? void 0 : _s.helpSettings) === null || _t === void 0 ? void 0 : _t.panelSettings, { onDismiss: this._closePanel, onDismissed: this._onFarRightButtonDismissed, hasCloseButton: false }), ((_v = (_u = this.props.farRightSettings) === null || _u === void 0 ? void 0 : _u.helpSettings) === null || _v === void 0 ? void 0 : _v.panelSettings.body) || null),
            React.createElement(CoherencePanel, __assign({ titleText: (_x = (_w = farRightSettings === null || farRightSettings === void 0 ? void 0 : farRightSettings.profileSettings) === null || _w === void 0 ? void 0 : _w.panelSettings.titleText) !== null && _x !== void 0 ? _x : 'Profile', isOpen: this.state.panelVisible === 'Profile' }, (_z = (_y = this.props.farRightSettings) === null || _y === void 0 ? void 0 : _y.profileSettings) === null || _z === void 0 ? void 0 : _z.panelSettings, { onDismiss: this._closePanel, onDismissed: this._onFarRightButtonDismissed, hasCloseButton: false }), this.getProfile())));
    };
    CoherenceHeaderBase.prototype._getRightFlexItems = function () {
        var farRightSettings = this.props.farRightSettings;
        if (!farRightSettings) {
            return [];
        }
        var items = farRightSettings.additionalItems ? __spreadArrays(farRightSettings.additionalItems) : [];
        if (farRightSettings.notificationsSettings) {
            var newNotifications = farRightSettings.notificationsSettings.panelSettings.newNotifications;
            var notificationButtonSettings = farRightSettings.notificationsSettings.buttonSettings;
            items.push(NotificationControl(newNotifications, this.state.panelVisible === 'Notifications', this.onClickNotifications, notificationButtonSettings === null || notificationButtonSettings === void 0 ? void 0 : notificationButtonSettings.title, notificationButtonSettings === null || notificationButtonSettings === void 0 ? void 0 : notificationButtonSettings.ariaLabel));
        }
        if (farRightSettings.settingsSettings) {
            items.push(this.getSettingsControl());
        }
        if (farRightSettings.helpSettings) {
            items.push(this.getHelpControl());
        }
        if (window.OfficeBrowserFeedback || farRightSettings.feedbackSettings) {
            items.push(this.getFeedbackControl());
        }
        return items;
    };
    CoherenceHeaderBase.prototype._getRightStaticItems = function () {
        var farRightSettings = this.props.farRightSettings;
        var items = [];
        if (farRightSettings && farRightSettings.profileSettings) {
            items.push(this.getPersonaCoin());
        }
        return items;
    };
    return CoherenceHeaderBase;
}(React.Component));
export { CoherenceHeaderBase };
//# sourceMappingURL=CoherenceHeader.base.js.map